import React from 'react'
import useSWR from 'swr'

import { fetcher } from '@/components/hackernews/PostsList'

export type DataRoutes = Record<string, string>

export function Routes({ apiUrl, title }: { apiUrl: string; title?: string }) {
  const { data, error } = useSWR<DataRoutes>(`${apiUrl}/help`, fetcher)

  if (error)
    return (
      <div>
        <h1 className="text-gray-400">{title}</h1>
        Error loading routes
      </div>
    )

  if (!data)
    return (
      <div>
        <h1 className="text-gray-400">{title}</h1>
        Loading routes...
      </div>
    )

  return (
    <div>
      <h1 className="text-gray-400">{title}</h1>
      <ul className="list-disc ml-4">
        {Object.keys(data).map((key) => {
          if (!data[key].includes('http')) {
            return <></>
          }
          return (
            <li key={key}>
              <a className="hover:text-blue-500" href={data[key]} target="_blank" rel="noreferrer">
                {data[key]}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
